import { useState, useEffect, useMemo } from 'react';
import user from '@/stores/user';
import { isEthereum } from '@/utils';
// utc 11-20 00:00:00
const EndTime = 1668902400000;

const now = new Date().getTime();

export default function useActivityShow() {
    const [timeEnd, setTimeEnd] = useState(now > EndTime);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date().getTime();

            if (now > EndTime) {
                setTimeEnd(true);
            }
        }, 30000);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [user.chainId]);

    return useMemo(() => {
        return isEthereum(user.chainId) && !timeEnd;
    }, [user.chainId, timeEnd]);
}
